import { render } from "./Champions.vue?vue&type=template&id=cb1af0ee"
import script from "./Champions.vue?vue&type=script&lang=js"
export * from "./Champions.vue?vue&type=script&lang=js"

import "./Champions.vue?vue&type=style&index=0&id=cb1af0ee&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__